/*
 * offers translations for the "en" locale.
 *
 * Split out of locales/en.js so this feature's copy stops shipping to
 * every route in the app. See locales/our-offers/index.js.
 */
export default {
    main_tags: {
      title: "Unlock Your Offers Now from Contact",
      meta_desc:
        "At Contact, we make sure your experience is always easy, simple, and rewarding. You can explore a wide range of exclusive deals directly from the Offers section on our app, and secure the ones that suit you best in just a few steps.",
    },
    valid_until: "Valid Until ",
    to_know: "To learn more about the offer, leave your details",
    no_data: "No Offers Now",
    hero_section: {
      title: "Unlock Your Offers Now from Contact",
      subtitle1:
        "At Contact, we make sure your experience is always easy, simple, and rewarding. You can explore a wide range of exclusive deals directly from the Offers section on our app, and secure the ones that suit you best in just a few steps.",
      subtitle2:
        "Download the ContactNow app today and enjoy a smooth, effortless journey with every offer you choose.",
      btn_download: "Download Now",
    },
    offers_steps: {
      title: "How to Apply for an Offer",
      subtitle:
        " If You’re Already a Contact Client, Follow these quick steps to apply for any offer:",
      steps: [
        {
          img: "https://contact-app-prod.s3.us-east-2.amazonaws.com/contact.eg/step-1.png",
          content: "Open the Contact App",
        },
        {
          img: "https://contact-app-prod.s3.us-east-2.amazonaws.com/contact.eg/step-2-en.webp",
          content:
            "Search for the merchant you want, or head straight to the Offers section.",
        },
        {
          img: "https://contact-app-prod.s3.us-east-2.amazonaws.com/contact.eg/step-3-en.webp",
          content: "Choose the offer that suits you.",
        },
        {
          img: "https://contact-app-prod.s3.us-east-2.amazonaws.com/contact.eg/step-4-en.webp",
          content: "Enter the required information.",
        },
        {
          img: "https://contact-app-prod.s3.us-east-2.amazonaws.com/contact.eg/step-5-en.webp",
          content: "The merchant will review your data on their portal.",
        },
        {
          img: "https://contact-app-prod.s3.us-east-2.amazonaws.com/contact.eg/step-6-en.webp",
          content: "Visit the merchant’s branch and wait for their approval",
        },
        {
          img: "https://contact-app-prod.s3.us-east-2.amazonaws.com/contact.eg/step-7.webp",
          content: "You’ll then receive an OTP on your phone.",
        },
        {
          img: "https://contact-app-prod.s3.us-east-2.amazonaws.com/contact.eg/step-8-en.webp",
          content: "Once you confirm the OTP, your transaction is completed.",
        },
      ],
    },

    faq: {
      title: "FAQS",
      items: [
        {
          q: "How long does it take for an offer to be approved?",
          a: `
      <p>Once your data is reviewed and verified, you will receive an OTP to complete your transaction. Visiting the merchant branch and providing accurate information helps speed up the process.</p>
      `,
        },

        {
          q: "Can I apply for more than one offer at the same time?",
          a: `
      <p>Yes, you can explore and apply for multiple offers that match your approved limit. Simply browse the Offers section, select the deals that suit you, and follow the application steps for each one directly through the <a href="https://play.google.com/store/apps/details?id=eg.contact">ContactNow App.</a></p>
      `,
        },

        {
          q: "How to Become a Contact Client and Get An Offer Today?",
          a: `
        <ul style="margin-top: 10px;">
           <li>Download <a href="https://play.google.com/store/apps/details?id=eg.contact">the ContactNow App.</a></li>
           <li>Create your account and complete your registration.</li>
           <li>You’ll receive a limit decision, either approved or declined.</li>
           <li>If approved, visit the nearest Contact branch within 30 days to sign your contract.</li>
           <li>After signing, you’re officially a Contact client and can start applying for offers.</li>
        </ul>
      `,
        },
      ],
    },
  };
